import React from 'react'; 
const LoaderComponent = (props) => {  
    return (
        <img alt="loader" className="loader-img" src="/images/loading_gray.gif" />
    );
};

export default LoaderComponent;